module.exports = __webpack_public_path__ + "img/loading.49419ccc.png";